// BenevvPopupEvents.tsx
import React from 'react';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import { Item } from './BenevvPopupEvent';
import BenevvPopupEvent from './BenevvPopupEvent';
import Typography from '@mui/material/Typography';

interface BenevvPopupEventsProps {
  data: Item[];
  selectedItems: number[];
  handleSelect: (id: number) => void;
  emptyMessage?: string;
}

const pairedData = (data: Item[]) => {
  const res: Item[][] = [];
  for (let i = 0; i < data.length; i += 2) {
    res.push(data.slice(i, i + 2));
  }
  return res;
}

const BenevvPopupEvents = ({ 
  data, 
  selectedItems, 
  handleSelect,
  emptyMessage = "No events to display" 
}: BenevvPopupEventsProps) => {
  if (data.length === 0) {
    return (
      <Box 
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '300px',
        padding: 3,
        textAlign: 'center',
        marginTop: '-40px'
      }}
      >
        <Typography variant="body1" 
          sx={{ 
            color: 'text.secondary',
            fontSize: 18,
          }}
        >
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      {pairedData(data).map((pair: Item[], index: number) => (
        <Box key={index} display="flex" justifyContent="space-between" marginBottom="8px">
          <List sx={{width: "100%"}}>
            <Box display="flex" justifyContent="space-between">
              {pair.map((item: Item) => (
                <Box key={item.id} width="48%">
                  <BenevvPopupEvent
                    item={item}
                    selected={selectedItems.includes(item.id)}
                    onClick={() => handleSelect(item.id)}
                  />
                </Box>
              ))}
            </Box>
          </List>
        </Box>
      ))}
    </Box>
  );
};

export default BenevvPopupEvents;
